import styled from 'styled-components';
import { Card, Segmented, Tabs } from 'antd';
import FormItem from 'antd/es/form/FormItem'
import Drawer from 'components/Drawer'
// No changes needed for CorporateDashboardCard
export const CorporateDashboardCard = styled(Card)`
  background-color: #ffffff;
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(0, 35, 102, 0.08);
  border: none;

  .ant-card-body {
    padding: 32px !important;
  }
`;

// This component is no longer used, but we can leave it
export const FilterCard = styled(Card)`
  display: inline-block;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid #e8e8e8;

  .ant-card-body {
    padding: 4px !important; 
  }
`;

// NEW: Horizontal tabs styled like the institute side
export const StyledHorizontalTabs = styled(Tabs)`
  .ant-tabs-nav {
    margin-bottom: 0;
    
    &::before {
      border-bottom: none;
    }
  }
  
  .ant-tabs-nav-list {
    background: #f8f9fa;
    border-radius: 8px;
    padding: 4px;
  }
  
  .ant-tabs-tab {
    border-radius: 6px;
    border: none;
    margin: 0 2px;
    padding: 8px 16px !important;
    background: transparent;
    color: #6c757d;
    font-weight: 500;
    transition: all 0.3s ease;
    
    &:hover {
      color: #3249D7;
    }
  }
  
  .ant-tabs-tab-active {
    background: #3249D7 !important;
    color: white !important;
    
    .ant-tabs-tab-btn {
      color: white !important;
    }
  }
  
  .ant-tabs-ink-bar {
    display: none;
  }
`;

// UPDATED: This style matches the white pill-button filter from your new image.
export const StyledSegmented = styled(Segmented)`
  background-color: #f0f5ff; /* Light grey background for the container */
  border-radius: 9px;
  padding: 4px;

  /* Style the sliding thumb to match the white selection */
  .ant-segmented-thumb {
    background-color: #ffffff !important; /* White background for selected item */
    border-radius: 7px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.05); /* Subtle shadow for depth */
  }

  /* Style each button */
  .ant-segmented-item {
    border-radius: 7px;
    color: #6c757d; /* Muted grey for unselected text */
    background-color: transparent;
    border: none;
    transition: color 0.2s ease;

    &:hover {
      color: #3855e0;
    }
  }

  /* Style for the selected button text */
  .ant-segmented-item-selected {
    color: #3855e0 !important; /* Blue text for selected item */
    font-weight: 500;
  }
`;

export const StyledDynamicText = styled.div`
  color: ${props => (props?.color ? props?.color : '#000000')};
  font-weight: ${props => (props?.weight ? props?.weight : '400')};
  font-size: ${props => (props?.size ? props?.size : '14px')};
  width: ${props => (props?.width ? props?.width : '100%')};
  padding-top: ${props => (props?.pt ? props?.pt : '0px')};
  padding-bottom: ${props => (props?.pb ? props?.pb : '0px')};
  padding-left: ${props => (props?.pl ? props?.pl : '0px')};
  padding-right: ${props => (props?.pr ? props?.pr : '0px')};
  margin-top: ${props => (props?.mt ? props?.mt : '0px')};
  margin-bottom: ${props => (props?.mb ? props?.mb : '0px')};
  margin-left: ${props => (props?.ml ? props?.ml : '0px')};
  margin-right: ${props => (props?.mr ? props?.mr : '0px')};
  text-align: ${props => (props?.align ? props?.align : 'left')};
`

export const FilterLabel = styled.p`
  color: #000000;
  font-size: 12px;
  font-weight: 600;
  white-space: ${props => (props.whiteSpace ? props.whiteSpace : '')};
`

export const StyledFormItem = styled(FormItem)`
  width: 100%;
`

export const StyledDrawer = styled(Drawer)(() => ({
  '.ant-drawer-header': {
    display: 'none',
  },
  '.ant-drawer-content': {
    height: 'auto',
  },
}))